import { render, staticRenderFns } from "./DisplayOptions.vue?vue&type=template&id=0b7ace74&scoped=true"
import script from "./DisplayOptions.vue?vue&type=script&lang=ts"
export * from "./DisplayOptions.vue?vue&type=script&lang=ts"
import style0 from "./DisplayOptions.vue?vue&type=style&index=0&id=0b7ace74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7ace74",
  null
  
)

export default component.exports